@use '../../styles/theme' as *;

.progress {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.progress-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 120px;
}

.progress--full-width {
  .progress-row {
    min-width: 0;
  }
  width: 100%;
}

.progress-bar-track {
  flex: 1;
  min-width: 0;
  height: 8px;
  border-radius: 4px;
  background-color: var(--neutral_600);
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  border-radius: 4px;
  background-color: var(--interactive_marker);
  transition: width var(--app-motion-standard);
  width: 0%;
}

.progress-value {
  @include text-8px-regular;
  color: var(--primary_text);
  flex-shrink: 0;
  min-width: 28px;
  text-align: right;
}

.progress-edge-labels {
  display: flex;
  justify-content: space-between;
  @include caption-2-capitalized;
  color: var(--secondary_text);
}
